/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CardOwnerSelect from './CardOwnerSelect/index'
import PaymentProviderCaptureMethod from 'DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/CreditCardCapture/Ready/Content"
  
}) {
let creditCardCaptureLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'credit_card_capture',
path: 'location_id',
})
let creditCardCaptureEffectivePersonValueData = fromData.useDataValue({ viewPath,
context: 'credit_card_capture',
path: 'effective_person',
})
  return (<React.Fragment
>
<CardOwnerSelect
  viewPath={`${viewPath}/CardOwnerSelect`}
/>
<PaymentProviderCaptureMethod
  viewPath={`${viewPath}/PaymentProviderCaptureMethod`}
 method="card"
 forceReuse={true}
 data="credit_card_capture.location_id"
 locationId={creditCardCaptureLocationIdValueData}
 data="credit_card_capture.effective_person"
 person={creditCardCaptureEffectivePersonValueData}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
{children}
</React.Fragment>)
}